// extracted by mini-css-extract-plugin
export default {"viewWishListButton":"viewWishListButton__03dffb"};